import { Injectable } from '@angular/core';
import { PaymentMode } from '@checkout/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CheckoutActions } from '../store/actions/';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class PaymentModeFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getList(): Observable<PaymentMode[]> {
    return this.store.pipe(select(CheckoutSelectors.getPaymentModeListValue));
  }

  getListLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getPaymentModeListLoading));
  }

  getListError(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getPaymentModeListError));
  }

  getListSuccess(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getPaymentModeListSuccess));
  }

  getActivePaymentCode(): Observable<string | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActivePaymentCode));
  }

  setActivePaymentMode(code: string): void {
    this.store.dispatch(new CheckoutActions.SetPayment(code));
  }

  resetActivePaymentMode(): void {
    this.store.dispatch(new CheckoutActions.DeletePayment());
  }

  initCardBindingOnExternalAddress(): void {
    this.store.dispatch(new CheckoutActions.InitCardBinding());
  }
}
